import React from 'react';
import { IconSpan } from '../../../../../../../components/IconSpan';
import { Link } from '../../../../../../../components/Link';
import { Icon } from '../../../../../../../components/Icon';
import { SignableDocument } from '../../../../../../../entities/v1/applicant_tracking/SignableDocument';

interface PropTypes {
  documents: SignableDocument[];
}

interface DocumentProps {
  document: SignableDocument;
}

function Document(props: DocumentProps) {
  return (
    <Link
      href={props.document.url}
      target='_blank'
      textClassNames='text-decoration-none'
    >
      <div className='d-flex align-items-center justify-content-between pt-2h'>
        <IconSpan
          spanText={
            <span className='fs-5 text-blue'>{props.document.fileName}</span>
          }
          icon={{
            name: 'bi bi-paperclip',
          }}
        />
        <Icon name={'bi-box-arrow-up-right'} className='text-blue' />
      </div>
    </Link>
  );
}

export function OfferDocuments(props: PropTypes) {
  return (
    <div>
      <h5>The candidate will receive these documents to sign:</h5>
      <div className='bg-gray p-3 rounded-2 pt-1'>
        {props.documents.map((document) => (
          <Document document={document} key={document.id} />
        ))}
      </div>
    </div>
  );
}
